module.exports = __webpack_public_path__ + "static/media/olivia-wilde-lesb.fc7ced7a.jpg";